import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src453302789/src/src/app/@travelCardModal/(...)travelCard/[id]/page.tsx");
